import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { OrdersPageConfig } from '@front-platform/content-builder';
import { ordersPageResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
export interface OrdersPageRuntimeConfig {
  'body'?: any;
}

export type OrdersPageConfigInput = Partial<
  Omit<OrdersPageConfig, keyof OrdersPageRuntimeConfig> & OrdersPageRuntimeConfig
>;
export type OrdersPageResolvedConfig = Omit<OrdersPageConfig, keyof OrdersPageRuntimeConfig> &
  Partial<OrdersPageRuntimeConfig>;
export interface OrdersPageContract extends ConfigComponentContract<
  OrdersPageConfigInput,
  OrdersPageResolvedConfig
> {}

@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
  standalone: false,
})
export class OrdersPageComponent implements OnInit, OrdersPageContract {
  readonly config = input<OrdersPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<OrdersPageConfig, OrdersPageRuntimeConfig>(
    ordersPageResolveConfig,
    () => ({ config: this.config() }),
  );
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'user-order-list',
      this.activatedRoute.snapshot,
    );
    // @todo: retrieve user orders
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(OrdersPageComponent, { 'keyAliases': {} });
